import React from 'react'
import styled, { css } from 'styled-components'

import { ThemeSpace } from 'theme/spaces'

export interface BoxProps {
  // paddings
  p?: ThemeSpace
  px?: ThemeSpace
  py?: ThemeSpace
  pt?: ThemeSpace
  pb?: ThemeSpace
  pl?: ThemeSpace
  pr?: ThemeSpace
  // margins
  m?: ThemeSpace
  mx?: ThemeSpace
  my?: ThemeSpace
  mt?: ThemeSpace
  mb?: ThemeSpace
  ml?: ThemeSpace
  mr?: ThemeSpace
  style?: React.CSSProperties
}

export const BoxStyles = css<BoxProps>`
  padding-top: ${({ theme, pt, py, p }) => {
    const paddingTop = pt || py || p
    return paddingTop && theme.space[paddingTop]
  }};
  padding-right: ${({ theme, pr, px, p }) => {
    const paddingRight = pr || px || p
    return paddingRight && theme.space[paddingRight]
  }};
  padding-bottom: ${({ theme, pb, py, p }) => {
    const paddingBottom = pb || py || p
    return paddingBottom && theme.space[paddingBottom]
  }};
  padding-left: ${({ theme, pl, px, p }) => {
    const paddingLeft = pl || px || p
    return paddingLeft && theme.space[paddingLeft]
  }};

  margin-top: ${({ theme, mt, my, m }) => {
    const marginTop = mt || my || m
    return marginTop && theme.space[marginTop]
  }};
  margin-right: ${({ theme, mr, mx, m }) => {
    const marginRight = mr || mx || m
    return marginRight && theme.space[marginRight]
  }};
  margin-bottom: ${({ theme, mb, my, m }) => {
    const marginBottom = mb || my || m
    return marginBottom && theme.space[marginBottom]
  }};
  margin-left: ${({ theme, ml, mx, m }) => {
    const marginLeft = ml || mx || m
    return marginLeft && theme.space[marginLeft]
  }};
`

const StyledBox = styled.div<BoxProps>`
  ${BoxStyles}
`

export const Box: React.FC<BoxProps> = ({
  p,
  px,
  py,
  pt,
  pb,
  pl,
  pr,
  m,
  mx,
  my,
  mt,
  mb,
  ml,
  mr,
  style,
  children,
  ...props
}) => {
  return (
    <StyledBox
      pt={pt}
      pr={pr}
      pb={pb}
      pl={pl}
      py={py}
      px={px}
      p={p}
      mt={mt}
      mr={mr}
      mb={mb}
      ml={ml}
      my={my}
      mx={mx}
      m={m}
      style={style}
      {...props}
    >
      {children}
    </StyledBox>
  )
}
